
import { Nav } from './components/nav'
import { Footer } from './components/transition-footer'
import { ScrollAnimation } from './components/scroll-animation'
import { PopUpVideo } from './components/popup-video'
import { ScrollTo } from './components/scroll-to'
import { Module02Intro } from './modules/module-02_intro'
import { Module09Collapses } from './modules/module-09_collapses'
import { Module10Logos } from './modules/module-10_logos'
import { Module11Faq } from './modules/module-11_faq'
import { Module13Team } from './modules/module-13_team'
import { Module17Slider } from './modules/module-17_slider'
import { Module20Sustain } from './modules/module-20_sustain'
import { Module23Survey } from './modules/module-23_survey'
import { ModuleFramework } from './modules/module-framework'
// import { DropDown } from './components/dropdown'

class App {
  constructor() {
    const nav = new Nav;
    const scrollAnimation = new ScrollAnimation;

    if(document.querySelector('.transition-footer_container')) {
      const footer = new Footer;
    }

    if(document.querySelector('.popup-video')) {
      const popupvideo = new PopUpVideo;
    }

    if(document.querySelector('.scrollto')) {
      const scrollTo = new ScrollTo;
    }

    if(document.querySelector('.module-02_intro.intro-anime')) {
      const module02Intro = new Module02Intro;
    }

    if(document.querySelector('.module-09_collapses')) {
      const module09Collapses = new Module09Collapses;
    }

    if(document.querySelector('.module-10_logos')) {
      const module10Logos = new Module10Logos;
    }

    if(document.querySelector('.module-11_faq')) {
      const module11Faq = new Module11Faq;
    }

    if(document.querySelector('.module-13_team')) {
      const module13Team = new Module13Team;
    }

    if(document.querySelector('.module-17_slider')) {
      const module17Slider = new Module17Slider;
    }

    if(document.querySelector('.module-20_sustain')) {
      const module20Sustain = new Module20Sustain;
    }

    if(document.querySelector('.module-23_survey')) {
      const module23Survey = new Module23Survey;
    }

    if(document.querySelector('.module-framework')) {
      const moduleFramework = new ModuleFramework;
    }
  }
}

window.onload = function() {
  let app = new App();
};
